import { To } from "history";

export const sectionQueryUrl = (section: string) =>
  `?${new URLSearchParams({ section }).toString()}`;

export const sectionTo = (section: string): To => ({
  search: sectionQueryUrl(section),
});
